<!--新建固件-->
<template>
  <el-dialog
    :title="addOrEditType === 'add' ? '新建固件版本' : '编辑固件版本'"
    :visible.sync="firmwareVersionVisible"
    width="628px"
    :before-close="handleClose"
    :close-on-click-modal="false">
    <el-form ref="form" :rules="rules" :model="form" label-width="160px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="固件名称" prop="name">
            <template #label>
              <span>固件名称</span>&nbsp;
              <el-tooltip content="仅用于管理固件，不对外显示" placement="top">
                <i class="iconfont icon-wenhao"></i>
              </el-tooltip>
            </template>
            <el-input
              v-if="addOrEditType === 'add' && pageType === 'firmwareDetails'"
              v-model="form.name"
              maxlength="32"
              show-word-limit
              placeholder="请输入固件名称"></el-input>
            <span v-else>{{ form.name }}</span>
          </el-form-item>
          <el-form-item label="固件版本" prop="version">
            <template #label>
              <span>固件版本</span>&nbsp;
              <el-tooltip placement="top">
                <template #content>
                  <p>①版本号根据 小数点(.) 分割，转成int 数组，依次顺序比较数组里的 int数字，数字大则版本号大;</p>
                  <p>②若数组的int数字均相同，则比较两个数组的长度，长度长的版本号大长度也相等的则两个版本号相等;</p>
                </template>
                <i class="iconfont icon-wenhao"></i>
              </el-tooltip>
            </template>
            <el-input
              v-if="addOrEditType === 'add'"
              v-model="form.version"
              maxlength="10"
              show-word-limit
              placeholder="版本号格式为xx.xx.xx，如1.0.0"></el-input>
            <span v-else>{{ form.version }}</span>
          </el-form-item>
          <el-form-item label="关键版本" prop="criticalVersionFlag">
            <template #label>
              <span>关键版本</span>&nbsp;
              <el-tooltip content="内容同原创建新固件中“关键版本为不可越过的版本，即当设定某个版本为关键版本后，即使发布了新的固件老固件也必须升级为关键版本，才可继续升级为最新版本" placement="top">
                <i class="iconfont icon-wenhao"></i>
              </el-tooltip>
            </template>
            <el-radio-group v-model="form.criticalVersionFlag">
              <!-- <el-radio :label="true">是</el-radio> -->
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="固件包" prop="package">
            <template #label>
              <span>固件包</span>&nbsp;
              <el-tooltip placement="top">
                <template #content>
                  <p>一般用于固件升级（OTA）的固件文件</p>
                  <p>全量升级类型的升级包上传不需要填写支持版本，其他类的升级包请务必填写支持设备版本</p>
                </template>
                <i class="iconfont icon-wenhao"></i>
              </el-tooltip>
            </template>
            <el-upload
              ref="firmwareUpload"
              class="upload-demo"
              action="#"
              :before-upload="beforeUpload"
              :on-error="uploadError"
              :on-exceed="handleExceed"
              :http-request="onHttpRequest"
              :limit="1"
              :disabled="isUploading"
              :file-list="fileList"
              :show-file-list="false">
              <el-button size="small" icon="el-icon-plus" :loading="isUploading" :disabled="isUploading">
                {{ uploadBtnText }}
              </el-button>
            </el-upload>

            <!-- 上传中 -->
            <div v-if="isUploading" class="upload-status-line">
              <div class="upload-status-text">
                <span class="upload-package-name" :title="uploadFileName">包名：{{ uploadFileName }}</span>
                <span v-if="statusText" class="upload-status-step">{{ statusText }}</span>
              </div>
              <div class="upload-progress-row">
                <el-progress
                  class="upload-progress-bar"
                  :percentage="uploadPercentage"
                  :stroke-width="6"
                  :show-text="false"
                  color="#275fe8">
                </el-progress>
                <span class="upload-progress-percent">{{ uploadPercentage }}%</span>
                <i
                  class="el-icon-close upload-cancel-icon"
                  title="取消上传"
                  @click="cancelUpload">
                </i>
              </div>
            </div>

            <!-- 上传结束：包名 + 成功/失败标记 -->
            <div v-else-if="uploadFileName" class="upload-result-line">
              <span class="upload-result-name" :title="uploadFileName">包名：{{ uploadFileName }}</span>
              <i v-if="uploadResult === 'success'" class="el-icon-success upload-result-icon success"></i>
              <i v-else-if="uploadResult === 'error'" class="el-icon-error upload-result-icon error"></i>
            </div>
          </el-form-item>
          <el-form-item label="版本说明" prop="description">
            <el-input
              v-model="form.description"
              type="textarea"
              maxlength="200"
              show-word-limit
              placeholder="请输入适当说明信息"></el-input>
          </el-form-item>
          <el-form-item label="" prop="isListed">
            <template #label>
              <span>是否上架</span>&nbsp;
              <el-tooltip content="上架操作后，才能进行固件升级和产品发布。选择上架则默认使用范围为“不限范围”" placement="top">
                <i class="iconfont icon-wenhao"></i>
              </el-tooltip>
            </template>
            <el-radio-group v-model="form.isListed">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="14" @click="handleClose">取消</el-button>
      <el-button type="primary" size="14" :disabled="isUploading" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { addFirmwareInfo, updateFirmwareVersion } from "@/api/product/firmware"
import { uploadFileToOBS } from "@/util/obs"
export default {
  name: "addFirmwareDialog",
  props: {
    addOrEditType: {
      type: String,
      default: 'add' // add 新建 edit 编辑
    },
    queryFirmwareManageList: {
      type: Function,
      default: () => { }
    },
    queryVersionList: {
      type: Function,
      default: () => { }
    },
    pageType: {
      type: String,
      default: 'firmwareManage' // firmwareManage 固件管理 firmwareDetails 固件详情
    },
    rowsData: {
      type: Object,
      default: () => ({})
    },
    rowsInline: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const validatePackage = (rule, value, callback) => {
      if (this.uploadResult !== 'success' || this.fileList.length === 0) {
        callback(new Error('请上传固件'))
      } else {
        callback()
      }
    }
    return {
      firmwareVersionVisible: false, // 弹窗是否显示
      form: {
        componentInfoId: '', // 固件Key
        name: '', // 固件名称
        version: '', // 固件版本
        criticalVersionFlag: false, // 关键版本
        description: '', // 版本说明
        isListed: true // 是否上架
      },
      fileList: [], // 上传的固件文件
      uploadSuccessOrError: false, // 上传成功标记（表单校验用）
      uploadResult: '', // success | error
      uploadFileName: '', // 已选/已传文件名
      firmwarePackage: {}, // 上传成功的固件包信息
      uploadLoading: false, // 保存提交中
      uploadPercentage: 0, // 整体上传进度 0~100（MD5+分片连续递增）
      isUploading: false, // 是否正在上传
      uploadAbortController: null, // 取消上传控制器
      uploadCancelNotified: false, // 取消提示是否已弹出（防重复）
      statusText: '', // 上传状态的文本
      // 生成1到180的数字数组作为选项
      upgradeChannelOptions: Array.from({ length: 180 }, (_, index) => index + 1),
      rules: {
        package: { required: true, validator: validatePackage, trigger: 'change' },
        name: [
          { required: true, message: '请输入固件名称', trigger: 'blur' }
          // { min: 1, max: 32, message: '请输入规范的固件名称', trigger: 'blur' }
          // { validator: this.validateName, trigger: 'blur' }
        ],
        version: [
          { required: true, message: '请输入固件版本', trigger: 'blur' }
        ],
        criticalVersionFlag: [
          { required: true, message: '请选择关键版本', trigger: 'change' }
        ],
        isListed: [
          { required: true, message: '请选择是否上架', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    uploadBtnText() {
      if (this.isUploading) return '正在上传中'
      if (this.uploadFileName) return '重新上传'
      return '上传固件'
    }
  },
  watch: {
    rowsData(newVal, oldVal) {
      this.form.componentInfoId = newVal.id
      if (this.pageType === 'firmwareManage') {
        this.form.name = newVal.name
      }
    },
    firmwareVersionVisible(val) {
      if (val) {
        // 每次打开弹窗时执行
        if (this.pageType === 'firmwareDetails' && this.addOrEditType === 'edit') {
          const newVal = this.rowsInline
          this.form.name = newVal.name
          this.form.version = newVal.version
          this.form.criticalVersionFlag = newVal.criticalVersionFlag
          this.form.description = newVal.description
          this.form.isListed = newVal.isListed
          this.firmwarePackage = {
            fileName: newVal.fileName,
            size: newVal.size,
            sign: newVal.sign,
            url: newVal.url
          }
          this.fileList = [{
            name: newVal.fileName,
            size: newVal.size
          }]
          this.uploadFileName = newVal.fileName
          this.uploadResult = 'success'
          this.uploadSuccessOrError = true
        }
      } else {
        // 关闭时可清理表单
        this.$refs.form && this.$refs.form.resetFields()
        this.resetUploadState({ abort: false })
      }
    }
  },
  created() { },
  methods: {
    // 固件上传前的校验
    beforeUpload(file) {
      if (file.name && file.name.includes(' ')) {
        this.$message.error('包名输入错误，请重新上传')
        return false
      }
      return true
    },
    // 已有文件时再次选择，覆盖上传
    handleExceed(files) {
      const upload = this.$refs.firmwareUpload
      if (!upload || !files || !files.length) return

      // 取消进行中的上传（静默，不弹「上传已取消」）
      if (this.isUploading && this.uploadAbortController) {
        this.uploadCancelNotified = true
        this.uploadAbortController.abort()
        this.uploadAbortController = null
      }

      upload.clearFiles()
      this.fileList = []
      this.uploadSuccessOrError = false
      this.uploadResult = ''
      this.uploadFileName = ''
      this.firmwarePackage = {}

      const rawFile = files[0]
      this.$nextTick(() => {
        upload.handleStart(rawFile)
        upload.submit()
      })
    },
    // 取消当前上传（先立刻刷新 UI，再中断后台任务）
    cancelUpload() {
      if (!this.isUploading) return

      if (!this.uploadCancelNotified) {
        this.uploadCancelNotified = true
        this.$message.info('上传已取消')
      }

      this.isUploading = false
      this.uploadPercentage = 0
      this.statusText = ''
      this.uploadResult = ''
      this.uploadFileName = ''
      this.uploadSuccessOrError = false
      this.fileList = []
      this.firmwarePackage = {}

      const controller = this.uploadAbortController
      this.uploadAbortController = null
      if (controller) {
        controller.abort()
      }

      const upload = this.$refs.firmwareUpload
      if (upload && typeof upload.clearFiles === 'function') {
        upload.clearFiles()
      }
    },
    // 固件上传失败
    uploadError(err) {
      this.isUploading = false
      this.uploadPercentage = 0
      this.$message.error(err)
    },
    // 重置上传相关状态
    resetUploadState({ abort = true } = {}) {
      if (abort && this.uploadAbortController) {
        this.uploadAbortController.abort()
        this.uploadAbortController = null
      }
      this.isUploading = false
      this.uploadPercentage = 0
      this.statusText = ''
      this.fileList = []
      this.uploadSuccessOrError = false
      this.uploadResult = ''
      this.uploadFileName = ''
      this.firmwarePackage = {}
    },
    // 自定义上传函数（OBS 通用上传）
    async onHttpRequest(options) {
      this.resetUploadState({ abort: false })
      this.isUploading = true
      this.uploadFileName = options.file.name
      this.uploadCancelNotified = false
      this.uploadAbortController = typeof AbortController !== 'undefined' ? new AbortController() : null

      try {
        const resData = await uploadFileToOBS(
          options.file,
          { obsEnums: 'OTA' },
          {
            onProgress: (percent) => {
              if (this.uploadCancelNotified || !this.isUploading) return
              if (percent >= this.uploadPercentage) {
                this.uploadPercentage = percent
              }
            },
            onStatus: (statusText) => {
              if (this.uploadCancelNotified || !this.isUploading) return
              this.statusText = statusText
            },
            signal: this.uploadAbortController ? this.uploadAbortController.signal : undefined
          }
        )

        if (this.uploadCancelNotified) return

        if (resData) {
          const fileName = resData.originFileName || resData.fileName || options.file.name
          this.fileList = [options.file]
          this.firmwarePackage = {
            ...resData,
            originFileName: fileName,
            fileName,
            sign: resData.md5 || resData.sign
          }
          this.uploadFileName = fileName
          this.uploadResult = 'success'
          this.uploadSuccessOrError = true
          this.$message.success('上传成功')
        } else {
          this.uploadResult = 'error'
          this.uploadSuccessOrError = false
          this.fileList = []
          this.firmwarePackage = {}
          this.$message.error('上传失败，返回数据为空')
        }
      } catch (error) {
        const aborted =
          this.uploadCancelNotified ||
          (error && error.message === '上传已取消') ||
          (error && error.code === 'ERR_CANCELED') ||
          (error && error.name === 'CanceledError') ||
          (error && error.name === 'AbortError')
        if (aborted) {
          if (!this.uploadCancelNotified) {
            this.uploadCancelNotified = true
            this.$message.info('上传已取消')
          }
          this.uploadResult = ''
          this.uploadFileName = ''
          this.uploadSuccessOrError = false
          this.fileList = []
          this.firmwarePackage = {}
        } else {
          console.error('上传失败:', error)
          this.$message.error((error && error.message) || '上传失败')
          this.uploadResult = 'error'
          this.uploadSuccessOrError = false
          this.fileList = []
          this.firmwarePackage = {}
        }
      } finally {
        this.isUploading = false
        this.uploadAbortController = null
        this.uploadPercentage = 0
        this.statusText = ''
      }
    },
    // 新建固件弹窗关闭
    handleClose() {
      if (this.isUploading && this.uploadAbortController) {
        this.uploadAbortController.abort()
        if (!this.uploadCancelNotified) {
          this.uploadCancelNotified = true
          this.$message.info('上传已取消')
        }
      }
      this.firmwareVersionVisible = false
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      this.resetUploadState({ abort: false })
    },
    // 提交
    handleSubmit() {
      if (this.isUploading) {
        this.$message.warning('固件正在上传中，请稍候')
        return
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            ...this.form,
            sign: this.firmwarePackage.sign,
            url: this.firmwarePackage.url,
            size: this.firmwarePackage.size,
            fileName: this.firmwarePackage.fileName,
            id: this.rowsInline.id
          }
          const func = this.addOrEditType === 'add' ? addFirmwareInfo : updateFirmwareVersion
          this.uploadLoading = true
          func(params).then((res) => {
            this.$message.success('上传成功')
            this.handleClose()
            this.uploadLoading = false
            // 返回固件管理列表页调用父组件方法刷新列表
            if (this.pageType === 'firmwareManage') {
              this.queryFirmwareManageList()
            } else if (this.pageType === 'firmwareDetails') {
              this.queryVersionList()
            }
          }).catch(err => {
            this.uploadLoading = false
            this.$message.error(err.message)
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-select {
  width: 100%;
}

::v-deep .upload-demo {
  .el-upload-list {
    display: none;
  }

  .el-upload {
    width: 100%;

    .el-button {
      color: #275fe8;
      width: 100%;
      font-size: 14px;
    }
  }
}

.upload-status-line {
  margin-top: 8px;
  width: 100%;
}

.upload-status-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 6px;
  color: #606266;
  font-size: 12px;
  line-height: 1.4;

  .el-icon-loading {
    margin-right: 6px;
    color: #275fe8;
  }
}

.upload-package-name {
  width: 100%;
  word-break: break-all;
  white-space: normal;
}

.upload-status-step {
  margin-top: 2px;
  color: #909399;
  font-size: 11px;
  line-height: 1.4;
}

.upload-progress-row {
  display: flex;
  align-items: center;
}

.upload-progress-bar {
  flex: 1;
  min-width: 0;
}

.upload-progress-percent {
  flex-shrink: 0;
  margin-left: 10px;
  color: #606266;
  font-size: 12px;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.upload-cancel-icon {
  flex-shrink: 0;
  margin-left: 8px;
  color: #909399;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    color: #f56c6c;
  }
}

.upload-result-line {
  display: flex;
  align-items: center;
  margin-top: 8px;
}

.upload-result-name {
  flex: 1;
  min-width: 0;
  color: #606266;
  font-size: 13px;
  line-height: 20px;
  word-break: break-all;
  white-space: normal;
}

.upload-result-icon {
  flex-shrink: 0;
  margin-left: 8px;
  font-size: 16px;
  line-height: 20px;

  &.success {
    color: #67c23a;
  }

  &.error {
    color: #f56c6c;
  }
}
</style>

